export const MEDIA_TYPES_FOR_END_CLIENT = {
    IMAGES:"images",
    VIDEO:"video",
    LINK:"link",
    DOCUMENT:"pdf"
}